import { render, staticRenderFns } from "./ConsenseComponent.vue?vue&type=template&id=3e04ee45"
import script from "./ConsenseComponent.vue?vue&type=script&lang=js"
export * from "./ConsenseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports